import { datadogRum } from '@datadog/browser-rum';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class LoggerService {
  constructor(
    @Inject('config') private config: any,
  ) {}

  public report(error: any): void {
    if (this.config.production) {
      datadogRum.addError(error);
    } else {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}
